import React, { useEffect, useState } from "react";
import Pic1 from "./../../assets/img/SPSingh.jpg";
import Pic2 from "./../../assets/img/mahabirSingh.jpg";
import Pic3 from "./../../assets/img/bharatsingh.jpg";
import Pic4 from "./../../assets/img/SPSingh.jpg";
import Pic5 from "./../../assets/img/jaibirSingh.jpg";
import Pic6 from "./../../assets/img/rahuldeepRana.jpg";
import Pic7 from "./../../assets/img/lalet.jpg";
import { useLocation } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";

const RegionalOffices = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const [images, setImages] = useState([]);
  
      useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const res = await axios.post(
              `${BaseUrl}/api/director/getAll`,
              { location: "Regional Office" },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
              const processedImages = res.data.data.map((img) => ({
                id: img.key,
                location: img.location,
                imageUrl: img.file ? `data:image/png;base64,${img.file}` : "",
                name:img.name,
                designation:img.designation,
                mobileNo:img.mobileNo,
                officeNo:img.officeNo,
                email:img.email,
                address:img.address,
              }));
    
              setImages(processedImages);
            } else {
              toast.error(res.data.message || "Failed to load images.");
            }
  
          } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred");
          }
          finally{
            setLoading(false);
          }
        };
    
        if (location.pathname) fetchData();
      }, [location.pathname]);
  return (
    <>
    {loading ? (
      <Loader />
    ) : (
    <div className="container my-3">
      <div className="abouts">
        <h5>Regional Offices</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <h6>HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED</h6>

        <p>(A STATE GOVT. UNDERTAKING)</p>

        <p>BEEJ BHAWAN, BAYS 3-6, SECTOR-2, PANCHKULA</p>

        <p>PHONE : 0172-2577755</p>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th>S.No.</th>
                <th>
                  Officer Name &amp;<br></br> Officer Address
                </th>
                <th>Designation</th>
                <th>Phone Nos.</th>
                <th>Mobile No.</th>
                <th >Email</th>
                <th>Photo</th>
              </tr>
              {images.length > 0 ? (
                            images.map((img,index) => (
                              <tr key={img.id}>
                                <td>{index+1}</td>
                                <td>{img.name} <br/> {img.address}</td>
                                <td>{img.designation}</td>
                                <td>{img.officeNo}</td>
                                <td>{img.mobileNo}</td>
                                <td>{img.email}</td>
                                <td>
                                  {img.imageUrl ? (
                                    <img
                                      src={img.imageUrl}
                                      alt={img.location}
                                      width="150"
                                      height="100"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                
                                
                                
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                No Data Found.
                              </td>
                            </tr>
                          )}


              {/* <tr>
                <td>1</td>
                <td>
                  <p>Sh. S.P. Singh</p>

                  <p>Haryana Seeds Dev. Corp. Ltd.,</p>

                  <p>G.T. Road, Near Pipli,</p>

                  <p>Umri (Kurukshetra)</p>
                </td>
                <td>Regional Manager (Officiating)</td>
                <td>01744-230339</td>
                <td>9416388861</td>
                <td>hsdcumri@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic1} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>Sh. Mahabir Singh</p>

                  <p>Haryana Seeds Dev. Corp. Ltd.,</p>

                  <p>4th Mile Stone, Sirsa Road,</p>

                  <p>Hisar</p>
                </td>
                <td>Regional Manager (Officiating)</td>
                <td>01662-275065</td>
                <td>9813854429</td>
                <td>hsdchsrestt@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic2} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>Sh. Bharat Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>4th Mile Stone, Hisar Road,</p>

                  <p>Sirsa</p>
                </td>
                <td>Manager (Officiating)</td>
                <td>01666-243297</td>
                <td>7988651861</td>
                <td>hsdcsirsa@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic3} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <p>Sh. S.P. Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>M-5, Ind. Area,</p>

                  <p>Yamuna Nagar</p>
                </td>
                <td>Manager (Additional Charge)</td>
                <td>01732-250391</td>
                <td>9416388861</td>
                <td>hsdcynr@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic4} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <p>Sh. Jaibir Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>Narhera Road</p>

                  <p>Pataudi (Gurgaon)</p>
                </td>
                <td>Manager</td>
                <td>0124-2672847</td>
                <td>9992110635</td>
                <td>hsdcptd@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic5} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  <p>Sh. Rahuldeep Rana</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>Dangra Road,</p>

                  <p>Tohana</p>
                  <p>(Fatehabad)</p>
                </td>
                <td>Manager (Officiating)</td>
                <td>01692-220879</td>
                <td>9991091214</td>
                <td>hsdc.tohana@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic6} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>

              <tr>
                <td>7</td>
                <td>
                  <p>Sh. Lalet</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>&nbsp;</p>

                  <p>Bhiwani</p>
                </td>
                <td>Marketing Officer (Officiating)</td>
                <td>01664-242243</td>
                <td>9467396381</td>
                <td>mohsdcbhiwani@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic7} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    )}
    </>
  );
};

export default RegionalOffices;
